import Vue from 'vue';
import store from './../../store';

const GET_LIST_URL = '/api/v1/lists/';

const successGetList = (response) => {
  store.dispatch('getList', response.data);
  // Vue.router.push({
  //   name: 'home.index',
  // });
  // return lookupResponse.data;
};

// When the request fails
const failedGetList = () => {
};

export default (listid) => {
  const axiosOptions = {
    timeout: 5000,
    headers: { 'X-Auth-Token': localStorage.getItem('jwt') },
    maxRedirects: 0,
    withCredentials: false,
  };
  // const queryinfo = {
  //   url: urltoquery,
  // };
  Vue.$http.get(GET_LIST_URL + listid, axiosOptions)
   .then((response) => {
     successGetList(response);
   })
   .catch((error) => {
     failedGetList(error);
   });
};



// WEBPACK FOOTER //
// ./src/app/services/list/getlist.js